import React, { useState } from 'react'
import { Grid } from '@material-ui/core'
import { Button } from '@progress/kendo-react-buttons'
import { Container } from '@material-ui/core'
import { useTranslation } from "react-i18next"
import './person-type.css'
import { Tooltip } from '@progress/kendo-react-tooltip'
import { Label } from '@progress/kendo-react-labels'

const TooltipContentTemplate = (props) => {
  return (
    <a>
      <strong>{props.title}</strong>
      <p>{props.content}</p>
      <p>{props.subContent}</p>
      <p>{props.restContent}</p>
    </a>
  );
};

const PersonTypePure = (props) => {
  const { t } = useTranslation()

  const iconTooltipStyles = {
    color: '#929292',
    fontSize: '20px',
    // marginLeft: '5px',
    padding: '5px',
    cursor: 'pointer'
  }

  const [open, setOpen] = useState(false);
  const handleOnChangeTooltip = () => setOpen(!open)
  const hiddeTooltip = () => setOpen(false)
  const { principalTitle, content, title } = props



  return (
    <Container style={{ marginTop: 20, display: 'grid', justifyContent: 'center' }} lg={3} md={3} sm={4} es={6} xs={12}>
      <Grid item>
        <img alt='Logo de govo.legal' src={props.image} className='person-type-image' />
      </Grid>
      <Grid item className='space-persons'>
        <h3 className='person-type-boldtext'>{props.name}</h3>
        <Tooltip
          position="right"
          anchorElement="target"
          content={(props) => {
            return <TooltipContentTemplate title={open ? title : props.title} content={open ? content : ''} />
          }}
        >
          <Label className="form-labels">
            <i
              className="k-icon k-i-information"
              style={iconTooltipStyles}
              title={t('signatureRequestView2.tooltipClic')}
              onClick={() => handleOnChangeTooltip()}
              onMouseOut={() => hiddeTooltip()}
            />
          </Label>
        </Tooltip>
      </Grid>
      <Grid item className='button-select-align'>
        <Button
          // primary 
          className='button-accept-type center-mi-firma data-akubicafirmadigital-person'
          onClick={() => {
            props.onSelectPersonType(props.id, props.name)
          }}
        >
          {t('button.accept')}
        </Button>
      </Grid>
    </Container>
  )
}

export { PersonTypePure as default }
